<template>
  <tr class="kt-datatable__row" v-if="!filteredOut">
    <td data-field class="kt-datatable__cell">
      <span>{{ order.sale_code }}</span>
    </td>
    <td data-field class="kt-datatable__cell">
      <span>{{ order.store_name }}</span>
    </td>
    <td data-field class="kt-datatable__cell">
      <span>{{ order.submitted }}</span>
    </td>
    <td data-field class="kt-datatable__cell">
      <span>{{ order.type }}</span>
    </td>
    <td data-field class="kt-datatable__cell">
      <span>{{ order.status }}</span>
    </td>
  </tr>
</template>

<script>
export default {
  name: "OrderSyncRow",
  props: ["order", "filters"],
  computed: {
    filteredOut() {
      if (
        this.searchFilteredOut ||
        this.statusFilteredOut ||
        this.typeFilteredOut
      ) {
        return true;
      }
      return false;
    },
    statusFilteredOut() {
      if (this.filters.status && this.filters.status.toLowerCase() !== "all") {
        if (
          this.filters.status.toLowerCase() !== this.order.status.toLowerCase()
        ) {
          return true;
        }
      }
      return false;
    },
    typeFilteredOut() {
      if (this.filters.type && this.filters.type.toLowerCase() !== "all") {
        if (this.filters.type.toLowerCase() !== this.order.type.toLowerCase()) {
          return true;
        }
      }
      return false;
    },
    searchFilteredOut() {
      if (!this.filters.search || !this.filters.search.length) {
        return false;
      }
      if (
        this.order.sale_code
          .toLowerCase()
          .indexOf(this.filters.search.toLowerCase()) !== -1 ||
        this.order.store_name
          .toLowerCase()
          .indexOf(this.filters.search.toLowerCase()) !== -1 ||
        this.order.status
          .toLowerCase()
          .indexOf(this.filters.search.toLowerCase()) !== -1 ||
        this.order.type
          .toLowerCase()
          .indexOf(this.filters.search.toLowerCase()) !== -1 ||
        this.order.submitted
          .toLowerCase()
          .indexOf(this.filters.search.toLowerCase()) !== -1
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
#orders_table {
  table {
    @media screen and (max-width: 470px) {
      width: 200%;
      border: 4px solid #f3f3f3;
    }
    .kt-datatable__body {
      th {
        span {
          font-weight: 700;
        }
      }

      th,
      td {
        width: 20% !important;
        /* word-break: break-all; */
        span {
          word-break: break-word;
        }
      }
      tr.kt-datatable__row {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &:hover {
          background-color: #aaaaff;
        }
      }
    }
  }
}
</style>